var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 19.9509V31.3497C38.0001 32.5119 37.5554 33.6301 36.7573 34.4749C35.9591 35.3196 34.8679 35.8269 33.7076 35.8927L33.45 35.8997H14.55C13.3878 35.8998 12.2696 35.4552 11.4249 34.657C10.5801 33.8588 10.0728 32.7677 10.007 31.6073L10 31.3497V19.9509L23.5128 27.0293C23.6631 27.1081 23.8303 27.1492 24 27.1492C24.1697 27.1492 24.3369 27.1081 24.4872 27.0293L38 19.9509Z",
    fill: "#E3E4E6",
    fillOpacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5499 13.5H33.4499C34.5777 13.4999 35.6654 13.9186 36.5019 14.675C37.3385 15.4314 37.8643 16.4715 37.9775 17.5936L23.9999 24.9156L10.0223 17.5936C10.1308 16.516 10.6201 15.5125 11.4023 14.7634C12.1845 14.0144 13.2082 13.5689 14.2895 13.507L14.5499 13.5H33.4499H14.5499Z",
    fill: "#E3E4E6",
    fillOpacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2266b8e19b62b81d35558abb1c066b92.svg";
export { ForwardRef as ReactComponent };